export const CHAIN_INSTANCE_LOAD_REQUESTED = "CHAIN_INSTANCE/LOAD_REQUESTED";
export const CHAIN_INSTANCE_LOAD_SUCCESS = "CHAIN_INSTANCE/LOAD_SUCCESS";
export const CHAIN_INSTANCE_LOAD_FAIL = "CHAIN_INSTANCE/LOAD_FAIL";
export const CHAIN_INSTANCE_SAVE_REQUESTED = "CHAIN_INSTANCE/SAVE_REQUESTED";
export const CHAIN_INSTANCE_SAVE_SUCCESS = "CHAIN_INSTANCE/SAVE_SUCCESS";
export const CHAIN_INSTANCE_SAVE_FAIL = "CHAIN_INSTANCE/SAVE_FAIL";
export default (state = {
    loading: 0,
    data: "",
    errors: []
}, { type, data }) => {
    switch (type) {
    case CHAIN_INSTANCE_LOAD_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CHAIN_INSTANCE_LOAD_SUCCESS: {
        --state.loading;
        state.data = data;
        return state;
    }
    case CHAIN_INSTANCE_LOAD_FAIL: {
        --state.loading;
        // state.errors.push({ error: data, type });
        return state;
    }
    case CHAIN_INSTANCE_SAVE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CHAIN_INSTANCE_SAVE_SUCCESS: {
        --state.loading;
        state.data = data;
        return state;
    }
    case CHAIN_INSTANCE_SAVE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    default:
        return state;
    }
};

export const loadRequested = data => ({ type: CHAIN_INSTANCE_LOAD_REQUESTED, data });
export const loadSuccess = data => ({ type: CHAIN_INSTANCE_LOAD_SUCCESS, data });
export const loadFail = data => ({ type: CHAIN_INSTANCE_LOAD_FAIL, data });
export const saveRequested = data => ({ type: CHAIN_INSTANCE_SAVE_REQUESTED, data });
export const saveSuccess = data => ({ type: CHAIN_INSTANCE_SAVE_SUCCESS, data });
export const saveFail = data => ({ type: CHAIN_INSTANCE_SAVE_FAIL, data });
